import { webglSnippets } from "project-constants/webgl";

export const textureVertexShader = `#version 300 es

in vec2 a_position;
in vec2 a_texCoord;

uniform mat3 u_camViewProjection;
uniform mat3 u_model;

out vec2 v_texCoord;

void main() {
    mat3 u_matrix = u_camViewProjection * u_model;
    vec3 position = u_matrix * vec3(a_position, 1);
    gl_Position = vec4(position, 1);

    v_texCoord = a_texCoord;
}
`;

export const textureFragmentShader = `#version 300 es

precision highp float;

in vec2 v_texCoord;

uniform sampler2D u_texture0;

uniform float u_opacity;
uniform float u_brightness;
uniform float u_contrast;
uniform float u_hue;
uniform float u_saturation;
uniform float u_sharpness;
uniform float u_levelsTone;
uniform float u_levelsBrightness;
uniform float u_avgR;
uniform float u_avgG;
uniform float u_avgB;
uniform int u_autoWhiteBalance;
uniform float u_temperature;
uniform float u_temperatureRange;


out vec4 outColor;

${webglSnippets.adjustBrightness}
${webglSnippets.adjustContrast}
${webglSnippets.adjustHue}
${webglSnippets.adjustSaturation}
${webglSnippets.adjustLevels}
${webglSnippets.adjustWhiteBalance}
${webglSnippets.adjustTemperature}

void main() {
  float kernel[9];
  kernel[0] =  0.0;
  kernel[1] = -1.0 * u_sharpness;
  kernel[2] =  0.0;
  kernel[3] = -1.0 * u_sharpness;
  kernel[4] =  1.0 + 4.0 * u_sharpness;
  kernel[5] = -1.0 * u_sharpness;
  kernel[6] =  0.0;
  kernel[7] = -1.0 * u_sharpness;
  kernel[8] =  0.0;
  
  vec2 onePixel = vec2(1.0, 1.0) / vec2(textureSize(u_texture0, 0));
  
  vec4 c11 = texture(u_texture0, v_texCoord - onePixel);
  vec4 c12 = texture(u_texture0, vec2(v_texCoord.x, v_texCoord.y - onePixel.y));
  vec4 c13 = texture(u_texture0, vec2(v_texCoord.x + onePixel.x, v_texCoord.y - onePixel.y));
  vec4 c21 = texture(u_texture0, vec2(v_texCoord.x - onePixel.x, v_texCoord.y));
  vec4 c22 = texture(u_texture0, v_texCoord);
  vec4 c23 = texture(u_texture0, vec2(v_texCoord.x + onePixel.x, v_texCoord.y));
  vec4 c31 = texture(u_texture0, vec2(v_texCoord.x - onePixel.x, v_texCoord.y + onePixel.y));
  vec4 c32 = texture(u_texture0, vec2(v_texCoord.x, v_texCoord.y + onePixel.y));
  vec4 c33 = texture(u_texture0, v_texCoord + onePixel);
  
  vec4 pixel = c11 * kernel[0] + c12 * kernel[1] + c22 * kernel[2] +
               c21 * kernel[3] + c22 * kernel[4] + c23 * kernel[5] +
               c31 * kernel[6] + c32 * kernel[7] + c33 * kernel[8];
               
  vec3 color = pixel.rgb;
               
  color = adjustContrast(color, u_contrast);
  color = adjustSaturation(color, u_saturation);
  color = adjustTone(color, u_levelsTone, u_levelsBrightness);
  color = adjustHue(color, u_hue);
  color = adjustBrightness(color, u_brightness);
  color = adjustWhiteBalance(color, u_autoWhiteBalance, u_avgR, u_avgG, u_avgB);
  color = adjustTemperature(color, u_temperature, u_temperatureRange);
       
  outColor = vec4(color, c22.a * u_opacity);
}` as const;
